import { render, staticRenderFns } from "./OdocCreateModal.vue?vue&type=template&id=1a826504"
import script from "./OdocCreateModal.vue?vue&type=script&lang=js"
export * from "./OdocCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports